import React, { useEffect, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom"; // For linking to the "Add New Project" page
import {
  getProjectRequests,
  unsetProjects,
} from "../../features/projectsSlice"; // Redux action to fetch ongoing projects
import Loading from "../../components/loading/Loading";
import PageTitle from "../../components/titles/PageTitle";
import SecondContainer from "../../components/container/SecondContainer";
import loadStatus from "../../util/loadStatus";
import NetworkError from "../error/NetworkError";
import PaginationSecondBar from "../../components/pagination/PaginationSecondBar";

const CommunityRequestApproval = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const projects = useSelector((state) => state.projects.data); // List of ongoing projects
  const total = useSelector((state) => state.projects.total);
  const user = useSelector((state) => state.user.userInfo); // List of ongoing projects
  let loading = useSelector((state) => state.projects.load.getProjectRequests);

  const onPageChange = async (limit, offset) => {
    try {
      const res = await dispatch(
        getProjectRequests({
          desk: "community",
          id: user.province_id,
          community_id: user.communities?.[0]?.id,
          limit,
          offset,
        })
      );
    } catch (error) {}
  };
  // useEffect(() => {}, [loading]);
  // Fetch ongoing projects when the component mounts if you belong to a community
  useLayoutEffect(() => {
    if (user.id && user.communities.length > 0) {
      dispatch(
        getProjectRequests({
          desk: "community",
          id: user.province_id,
          community_id: user.communities?.[0]?.id,
        })
      );
    } else {
      loading = false;
    }
    return () => {
      dispatch(unsetProjects());
    };
  }, [user]);

  if (loading === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <SecondContainer className=" ">
      {/* Basic Instructions */}
      {/* <h1 className="text-2xl text font-bold mb-4">Ongoing Applications</h1> */}
      <PageTitle title="Community Review & Approvals" />
      <p className="mb-4 text-text-1/65">
        Below is a list of all ongoing applications pending Approval
      </p>

      <PaginationSecondBar
        loading={loading}
        onPageChange={onPageChange}
        total={total}
      />

      {/* Ongoing Applications Table */}
      {user.communities?.length < 1 ? (
        <div className="flex flex-col items-center justify-center w-full h-72 border border-bkg2 rounded-md">
          <p className="text-text-1/60">You do not belong to any Community.</p>
          <p className="text-text-1/60">Please Contact your Administrator.</p>
        </div>
      ) : (
        <div className="table-container">
          <table className="app-table">
            <thead className=" app-thead">
              <tr>
                <th className="app-thead-th">Num</th>
                <th className="app-thead-th">Title</th>
                <th className="app-thead-th">Date Started</th>
                <th className="app-thead-th">Status</th>
                <th className="app-thead-th">Action</th>
              </tr>
            </thead>
            <tbody className="text-text-1/85">
              {loading ? (
                <tr className="!border-none !bg-transparent">
                  <td colSpan={5} className="!border-none !border-transparent ">
                    <div className="h-72 flex items-center justify-center mx-auto w-fit !border-none">
                      <Loading />
                    </div>
                  </td>
                </tr>
              ) : projects.length > 0 ? (
                projects.map((project, index) => (
                  <tr key={project.id}>
                    {/* Project Num */}
                    <td className="table-data !text-sm">{++index}</td>
                    {/* Project Title */}
                    <td className="table-data !text-base">
                      {project.name.length >= 30
                        ? project.name.slice(0, 35) + "....."
                        : project.name}
                    </td>

                    {/* Date Started */}
                    <td className="table-data !text-sm">
                      {new Date(project.updated_at).toDateString()}
                    </td>

                    {/* Step Reached (Assumed it's available in the project object) */}
                    <td className="table-data !text-sm">
                      {project.stage.step || "Not Started"}
                    </td>

                    {/* Continue Application Button */}
                    <td className="table-data !text-sm text-center">
                      {/* <Link to={"/requests/beneficiary-profile/" + project.id}>
                    <button className="px-4 py-2 bg-green-500/80 text-text-gen rounded hover:bg-green-600">
                      Cont.. Application
                    </button>
                  </Link> */}
                      {project.stage?.desk === "community" ? (
                        <Link to={project.stage.url}>
                          <button className="px-4 py-2 bg-green-500/80 text-text-gen rounded hover:bg-green-600">
                            Review Application
                          </button>
                        </Link>
                      ) : (
                        <p className="inline-block px-4 py-2 bg-slate-400 text-text-gen rounded ">
                          Pending Approval
                        </p>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <>
                  <tr className="!border-none !bg-transparent">
                    <td
                      colSpan={6}
                      className="!border-none !border-transparent "
                    >
                      <div className="flex items-center justify-center w-full h-72 border border-bkg2 rounded-md">
                        <p className="text-text-1/60">
                          No ongoing Applications found.
                        </p>
                      </div>
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>
      )}
    </SecondContainer>
  );
};

export default CommunityRequestApproval;
